"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_1 = __importDefault(require("analytics"));
const segment_1 = __importDefault(require("@analytics/segment"));
const base_analytics_provider_1 = require("./base-analytics-provider");
const client_sdk_common_1 = require("@easygenerator/client-sdk.common");
const AllowedEventsForSend = ['UserRegistered_Complete Signup', 'GA connector data', 'profiling_question_answered'];
class SegmentProvider extends base_analytics_provider_1.BaseAnalyticsProvider {
    constructor(initData) {
        super();
        this.isDeactivatedSegmentAllowed = false;
        this.onFeatureFlagsUpdate = () => {
            this.isDeactivatedSegmentAllowed = client_sdk_common_1.FeatureFlagsProvider.featureFlags.isFeatureEnabled('deactivate-segment');
        };
        const { segmentWriteKey } = initData;
        this.analytics = (0, analytics_1.default)({
            app: 'Easygenerator',
            plugins: [(0, segment_1.default)({ writeKey: segmentWriteKey })]
        });
        this.analytics.on('ready', () => {
            this.onFeatureFlagsUpdate();
            this.trackPage();
        });
        this.isInitialized = true;
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.on('update', this.onFeatureFlagsUpdate);
    }
    identifyUser(identity) {
        const { id, ...rest } = identity;
        if (!id.length) {
            return;
        }
        this.userId = id;
        this.analytics.reset();
        this.analytics.identify(id, rest);
    }
    updateUserIdentity(id, userProps) {
        this.analytics.identify(id, { ...userProps });
    }
    track(eventName, properties) {
        try {
            if (this.isDeactivatedSegmentAllowed && !AllowedEventsForSend.includes(eventName)) {
                return;
            }
            this.analytics.track(eventName, properties);
        }
        catch (err) {
            const { log } = console;
            log(err);
        }
    }
    trackPage() {
        if (this.isDeactivatedSegmentAllowed) {
            return;
        }
        if (!this.userId || (this.userId && this.userId.length === 0)) {
            return;
        }
        this.analytics.page({});
    }
    performLogout() {
        this.analytics.reset();
        client_sdk_common_1.FeatureFlagsProvider.featureFlags.off('update', this.onFeatureFlagsUpdate);
    }
}
exports.default = SegmentProvider;
